import { call, put, takeEvery } from 'redux-saga/effects';
import { addLevels, deleteLevels, getAllGrades, getById, getCourseMapping,  getCourseMappingV2, getGradeMappingInfo, getLevels } from "./IRGradingBaseApi";
import { toastAction } from '../toast/toast';
import { irGradeAction } from "./IRGradingSlice";


export function* onChangeGradeMapping(payload) {
    try {
        const data = yield call(getGradeMappingInfo, payload);

        yield put(irGradeAction.setGradeMapping(data || []));
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message || error.error))
    }
}

export function* onChangeCourseMapping(payload) {
    try {
        const data = yield call(getCourseMapping, payload);
        yield put(irGradeAction.setCourseMapping(data || []));
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message || error.error))
    }
}

export function* onChangeCourseMappingV2(payload) {
    try {
        const data = yield call(getCourseMappingV2, payload);
        yield put(irGradeAction.setCourseMappingV2(data || []));
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message || error.error))
    }
}

export function* onChangeCurrentGradeMapping({ payload }) {
    try {
        // const  data  = yield call(getById, payload);
        // console.log(data);
        // yield put(irGradeAction.setCurrentGrade(data || {}));
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message))
    }
}

export function* onChangeLevels (payload){
    try{
        const data = yield call(getLevels,payload);
        yield put(irGradeAction.setLevels(data || []));
    }catch(error){
         yield put(toastAction.onErrorToast(error?.message))
    }
}

export function* onAddLevel({payload}){
    try{
        const response = yield call(addLevels, payload);
        yield put(irGradeAction.addLevelSuccess(response.data));
        yield put(irGradeAction.loadLevels({}));
        yield put(toastAction.onSuccToast("Level added successfully"));
    }catch(error){
        yield put(toastAction.onErrorToast(error?.message || "Failed to add level"));
    }
}

export function* onDeleteLevel({payload}){
    try{
        yield call(deleteLevels, payload);
        yield put(irGradeAction.removeLevel(payload));
        yield put(irGradeAction.loadLevels({}));
        yield put(toastAction.onSuccToast("Level deleted successfully"));
    }catch(error){
        yield put(toastAction.onErrorToast(error?.message || 'Failed to delete Level'));
    }
}


export function* onSaveCurrentGradeMapping({ payload }) {
    let { grade, navigate } = payload;
    try {
        // const { data, message } = yield call(updateById, grade);
        // yield put(irGradeAction.setCurrentGrade(grade || {}));
        // yield put(toastAction.onSuccToast(message))
        try {
            // navigate('/grading-model', { replace: true });
        } catch (e) { }
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message || error.error))
    }
}

export function* onCreateGradeMapping({ payload }) {

    let { grade, navigate } = payload;
    try {
        // yield put(irGradeAction.createGradeMapping(grade));
        // yield put(irGradeAction.createGradeMapping(payload));
        // const { data, message } = yield call(createGrade, grade);
        // yield put(toastAction.onSuccToast(message))
        try {
            navigate('/ir-grading', { replace: true });
        } catch (e) { }
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message || error.error))
    }
}

export function* onDeleteGradeMapping({ payload }) {
    try {
        yield put(irGradeAction.deleteGradeMapping(payload));

        // const { data, message } = yield call(deleteGrade, payload);
        // yield put(toastAction.onSuccToast(message))
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message || error.error));
    }
}

export function* onChangeGrades({ payload }) {
    try {
        const data = yield call(getAllGrades, payload);
        yield put(irGradeAction.setGrades(data || []));
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message || error.error));
    }
}



function* irGradeWatcherSaga() {
    yield takeEvery(irGradeAction.loadGradeMapping.type, onChangeGradeMapping);
    yield takeEvery(irGradeAction.loadCourseMapping.type, onChangeCourseMapping);
    yield takeEvery(irGradeAction.loadCourseMappingV2.type, onChangeCourseMappingV2);
    yield takeEvery(irGradeAction.loadCurrentGradeMapping.type, onChangeCurrentGradeMapping);
    yield takeEvery(irGradeAction.saveCurrentGradeMapping.type, onSaveCurrentGradeMapping);
    yield takeEvery(irGradeAction.createGradeMapping.type, onCreateGradeMapping);
    yield takeEvery(irGradeAction.removeGradeMapping.type, onDeleteGradeMapping);
    yield takeEvery(irGradeAction.loadAllGrades.type, onChangeGrades);
    yield takeEvery(irGradeAction.loadLevels.type,onChangeLevels);
    yield takeEvery(irGradeAction.addLevel.type,onAddLevel);
    yield takeEvery(irGradeAction.deleteLevel.type, onDeleteLevel);

}
export default irGradeWatcherSaga;